<template>
    <div id="games-modal" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="gamesModalTitle"
         aria-hidden="true" v-if="this.selected">
        <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
            <div class="modal-content">

                <div class="modal-body d-flex flex-column text-center mt-3 mb-lg-5 mx-lg-5 px-lg-5">

                    <div class="text-center">
                        <img :src="this.selected.logo" alt="" class="text-center img-fluid logo">

                        <div class="close">
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>

                    </div>

                    <p v-text="this.selected.description" class="mb-1 mb-lg-3"></p>

                    <h6 class="mb-3 pt-3">Cum îl joci</h6>
                    <p v-text="this.selected.howToPlay" class="mb-1 mb-lg-3"></p>

                    <div id="game-carousel" class="d-none">
                        <div class="item">
                            <img :src="getImage('1')" alt="" class="img-fluid px-2">
                        </div>
                        <div class="item">
                            <img :src="getImage('2')" alt="" class="img-fluid px-2">
                        </div>
                        <div class="item">
                            <img :src="getImage('3')" alt="" class="img-fluid px-2">
                        </div>
                    </div>

                    <div id="loading-modal" class="w-100">
                        <div class="h-100">
                            <img src="../../assets/imgs/general/dintica-loader.png" alt="" class="img-fluid">
                        </div>
                    </div>
                </div>


            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "GamesModal",
        props: ['selected'],
        data() {
            return {
                loading: true
            }
        },
        watch: {
            'selected': function () {
                console.log('selected watch');
                const $ = window.$;
                let carousel = $('#game-carousel');
                carousel.addClass('d-none');
                $('#loading-modal').removeClass('d-none');

                this.refreshGameCarousel();
            }
        },
        mounted() {
            const $ = window.$;
            let carousel = $('#game-carousel');

            $(function () {
                setTimeout(function () {
                    console.log('timeout');
                    carousel.slick({
                        dots: true,
                        infinite: true,
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        centerPadding: '120px',
                        centerMode: true,
                        focusOnSelect: true,
                        cssEase: 'linear',
                        responsive: [
                            {
                                breakpoint: 769,
                                settings: {
                                    centerPadding: '40px',
                                    slidesToShow: 1,
                                    slidesToScroll: 1,
                                    infinite: true,
                                    dots: true
                                }
                            }
                        ]
                    });
                    carousel.removeClass('d-none');
                    $('#loading-modal').addClass('d-none');
                    this.loading = false;
                }, 1000);
            });


        },
        methods: {
            getImage(number) {
                return require('../../assets/imgs/games/' + this.selected.name + '/' + number + '.png');
            },
            refreshGameCarousel() {
                const $ = window.$;
                let carousel = $('#game-carousel');

                setTimeout(function () {
                    console.log('timeout');
                    carousel.slick('refresh');
                    carousel.removeClass('d-none');
                    $('#loading-modal').addClass('d-none');
                    this.loading = false;


                    console.log('tedfdfd', document.getElementById('games-modal').classList.contains('show') )
                    if (document.getElementById('games-modal').classList.contains('show')) {
                        console.log('tezt')
                    }

                }, 1000);

            },
        }

    }
</script>

<style lang="scss">
    @import "../../styles/games-modal.scss";
</style>